import {
    FETCH_CREATE_GROUPS_REQUEST,
    FETCH_CREATE_GROUPS_SUCCESS,
    FETCH_CREATE_GROUPS_FAILURE,
} from '../../actions/groups/create-group-action';

const initialState = {
    createdGroup: null,
    isLoading: false,
    error: null,
};

const CLEAR_DATA = "CLEAR_DATA";
const CreateGroupReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case FETCH_CREATE_GROUPS_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case FETCH_CREATE_GROUPS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                createdGroup: { ...action.payload[0] },
            };
        case FETCH_CREATE_GROUPS_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
        case CLEAR_DATA:
            return {
                ...initialState
            };
        default:
            return state;
    }
};

export default CreateGroupReducer;